import { FC } from "react";
import PickupAndReturn from "../../pages/GuideTour/components/PickupAndReturn";
import UiSection from "../box/UiSection";
import { RichTextBox } from "../richtext/RichTextBox";
import { ProductMap } from "./ProductMap";
import { TourExtraInfo } from "./TourExtraInfo";
export const ProductInformation: FC<ProdDetailEleProps> = (props) => {
  const d = props.d;
  return (
    <UiSection title="" className="border-t-0">
      <RichTextBox richtext={d?.information} />
      <div className="md:hidden">
        <ProductMap d={d} />
      </div>
      <TourExtraInfo d={d} />
      <PickupAndReturn d={d} />
    </UiSection>
  );
};
